import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';

import { AvailableFeaturesForm } from '../../constants';
import { fetchActivityTypes } from '../../actions';
import AvailableFeatures from './AvailableFeatures';
import journeyStatusEnums from '../../../../Enums/journeyStatus';

const styles = {
  main: {
    flexGrow: 1,
    padding: '0 16px 16px',
    marginBottom: 20,
  },
};

export const mapStateToProps = state => {
  const { journeyBuilderUIDataArea } = state;
  const { id } = journeyBuilderUIDataArea.userData.value.organization;
  const { sharedData } = journeyBuilderUIDataArea;
  const { isLoading, activityTypes } = sharedData;

  const args = state.journeyBuilderConfigurationArea.activity.arguments;
  const journeyStatus = state.journeyBuilderConfigurationArea.interaction.status;
  const status =
    journeyStatus === journeyStatusEnums.DRAFT || journeyStatus === journeyStatusEnums.PAUSED
      ? false
      : true;
  const selector = formValueSelector(AvailableFeaturesForm);
  let activityType = selector(state, 'activityType');
  if (
    !activityType &&
    args.execute.inArguments.length > 0 &&
    !_.isEmpty(args.execute.inArguments[0].activityType)
  ) {
    //Handle old optimizer node MessageFrequencyCapping config
    activityType = Array.isArray(args.execute.inArguments[0].activityType)
      ? args.execute.inArguments[0].activityType
      : args.execute.inArguments[0].activityType.split(',');
  }

  return {
    activityType: activityType ? activityType : [],
    isActivityTypeLoading: isLoading,
    activityTypes,
    buID: id,
    status,
    initialValues: {
      // eslint-disable-next-line iqvia/ternaries/no-empty-ternary
      activityType: activityType ? activityType : [],
      // activityTypes && activityTypes.length > 0 ? [...activityTypes[0].description] : [],
    },
  };
};

const mapDispatchToProps = {
  fetchActivityTypes,
};

export const enhance = lifecycle({
  componentDidMount() {
    if (_.isEmpty(this.props.activityTypes)) {
      const { fetchActivityTypes } = this.props;
      fetchActivityTypes();
    }
  },
})(AvailableFeatures);

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    form: AvailableFeaturesForm,
    enableReinitialize: true,
    destroyOnUnmount: false,
  }),
  injectIntl,
  withStyles(styles, { name: 'AvailableFeatures' })
)(enhance);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/components/AvailableFeatures/index.js